// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YFhBJ","actionsList":"styles_actionsList__KzLD8","task":"styles_task__aYWCk"};